import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/master-data',
    redirect: { name: 'yearlyEventList' },
    name: 'masterDataList',
    component: () => import('../pages/MasterDataDetailsPage.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'work-months',
        name: 'workMonthList',
        component: () => import('../relations/work-month/pages/WorkMonthListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'yearly-events',
        name: 'yearlyEventList',
        component: () => import('../relations/yearly-event/pages/YearlyEventListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'amounts',
        name: 'amountList',
        component: () => import('../relations/amount/pages/AmountListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'courses',
        name: 'courseList',
        component: () => import('../relations/course/pages/CourseListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'hospitals',
        name: 'hospitalList',
        component: () => import('../relations/hospital/pages/HospitalListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'education-types',
        name: 'educationTypeList',
        component: () => import('../relations/education-type/pages/EducationTypeListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'education-forms',
        name: 'educationFormList',
        component: () => import('../relations/education-form/pages/EducationFormListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'education-locations',
        name: 'educationLocationList',
        component: () => import('../relations/education-location/pages/EducationLocationListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'instructor-statuses',
        name: 'instructorStatusList',
        component: () => import('../relations/instructor-status/pages/InstructorStatusListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'specialties',
        name: 'specialityList',
        component: () => import('../relations/speciality/pages/SpecialityListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'legislations',
        name: 'legislationList',
        component: () => import('../relations/legislation/pages/LegislationListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'speciality-has-courses',
        name: 'specialityHasCourseList',
        component: () => import('../relations/speciality-has-course/pages/SpecialityHasCourseListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'nationalities',
        name: 'nationalityList',
        component: () => import('../relations/nationality/pages/NationalityListPage.vue'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;
